"use client";

import IceCream from "~/assets/ice-creams/icon.svg";
import SquareIcon from "~/assets/ice-creams/square.svg";
import ListIcon from "~/assets/ice-creams/list.svg";
import PineappleIcon from "~/assets/ice-creams/pineapple.svg";
import BananaIcon from "~/assets/ice-creams/banana.svg";
import BlueberryIcon from "~/assets/ice-creams/blueberry.svg";
import PeachIcon from "~/assets/ice-creams/peach.svg";
import LemonIcon from "~/assets/ice-creams/lemon.svg";
import BlackberryIcon from "~/assets/ice-creams/blackberry.svg";
import GrapefruitIcon from "~/assets/ice-creams/grapefruit.svg";
import PearIcon from "~/assets/ice-creams/pear.svg";
import StrawberryIcon from "~/assets/ice-creams/strawberry.svg";
import KiwiIcon from "~/assets/ice-creams/kiwi.svg";
import ForestFruitIcon from "~/assets/ice-creams/forest-fruit.svg";
import LimeIcon from "~/assets/ice-creams/lime.svg";
import RaspberryIcon from "~/assets/ice-creams/raspberry.svg";
import MangoIcon from "~/assets/ice-creams/mango.svg";
import MaracujaIcon from "~/assets/ice-creams/maracuja.svg";
import WatermelonIcon from "~/assets/ice-creams/watermelon.svg";
import ApricotIcon from "~/assets/ice-creams/apricot.svg";
import OrangeIcon from "~/assets/ice-creams/orange.svg";
import CherryIcon from "~/assets/ice-creams/cherry.svg";
import SourCherryIcon from "~/assets/ice-creams/sour-cherry.svg";
import YellowMelonIcon from "~/assets/ice-creams/yellow-melon.svg";
import PeanutIcon from "~/assets/ice-creams/peanut.svg";
import ChocolateIcon from "~/assets/ice-creams/chocolate.svg";
import IrishCoffeeIcon from "~/assets/ice-creams/irish-coffee.svg";
import ApplePieIcon from "~/assets/ice-creams/apple-pie.svg";
import YogurtIcon from "~/assets/ice-creams/yogurt.svg";
import CaramelIcon from "~/assets/ice-creams/caramel.svg";
import CoffeeIcon from "~/assets/ice-creams/coffee.svg";
import CoconutIcon from "~/assets/ice-creams/coconut.svg";
import HazelnutIcon from "~/assets/ice-creams/hazelnut.svg";
import MalagaIcon from "~/assets/ice-creams/malaga.svg";
import MarzipanIcon from "~/assets/ice-creams/marzipan.svg";
import MintIcon from "~/assets/ice-creams/mint.svg";
import PistachioIcon from "~/assets/ice-creams/pistachio.svg";
import ProtiranaVisenIcon from "~/assets/ice-creams/protirana-visen.svg";
import PuncIcon from "~/assets/ice-creams/punc.svg";
import CinnamonIcon from "~/assets/ice-creams/cinnamon.svg";
import CreamIcon from "~/assets/ice-creams/cream.svg";
import StracciatellaIcon from "~/assets/ice-creams/stracciatella.svg";
import TvarohIcon from "~/assets/ice-creams/tvaroh.svg";
import TiramisuIcon from "~/assets/ice-creams/tiramisu.svg";
import VanillaIcon from "~/assets/ice-creams/vanilla.svg";
import GingerIcon from "~/assets/ice-creams/ginger.svg";
import GreenTeaIcon from "~/assets/ice-creams/green-tea.svg";
import HeaderSection from "~/components/ui/HeaderSection";
import { type ReactNode, useState } from "react";

export default function Page() {
  const [isListView, setListView] = useState(false);

  return (
    <>
      <main className="container-section">
        <HeaderSection
          image={<IceCream />}
          title="Zmrzliny"
          text="Nabídka zmrzlin pro odběratele a návštěvníky prodejny. Každý den je ve zmrzlinárně k prodeji výtažek
            několika zmrzlin z tohoto výběru a někdy i překvapení."
        >
          <label className="relative inline-block h-[50px] w-[120px] rounded-full border-0 bg-[#007BB30A] leading-[30px] hover:cursor-pointer">
            <input
              type="checkbox"
              className="slide hidden"
              checked={!isListView}
              onChange={() => setListView(!isListView)}
            />
            <div className="slider checked"></div>
            <span className="on">
              <SquareIcon />
            </span>
            <span className="off">
              <ListIcon />
            </span>
          </label>
        </HeaderSection>

        <section className="mt-20">
          <p className="font-bold text-primary">Druh</p>
          <h2 className="h1 text-primary">Sorbety</h2>
          <div className="mt-12 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
            <IceCreamCard
              title="Ananas"
              photo={<PineappleIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Banán"
              photo={<BananaIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Borůvka"
              photo={<BlueberryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Broskev"
              photo={<PeachIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Citron"
              photo={<LemonIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Černý rybíz"
              photo={<BlackberryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Červený grapefruit"
              photo={<GrapefruitIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Hruška"
              photo={<PearIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Jahoda"
              photo={<StrawberryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Kiwi"
              photo={<KiwiIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Lesní ovoce"
              photo={<ForestFruitIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Limetka"
              photo={<LimeIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Malina"
              photo={<RaspberryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Mango"
              photo={<MangoIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Maracuja"
              photo={<MaracujaIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Meloun"
              photo={<WatermelonIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Meruňka"
              photo={<ApricotIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Pomeranč"
              photo={<OrangeIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Třešeň brazilská - acerola"
              photo={<CherryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Višeň"
              photo={<SourCherryIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Žlutý meloun"
              photo={<YellowMelonIcon />}
              listView={isListView}
            />
          </div>
        </section>

        <section className="mt-20">
          <p className="font-bold text-primary">Druh</p>
          <h2 className="h1 text-primary">Smetanové zmrzliny</h2>
          <div className="mt-12 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
            <IceCreamCard
              title="Arašída"
              photo={<PeanutIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Čokoláda"
              photo={<ChocolateIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Irská káva"
              photo={<IrishCoffeeIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Jablečný koláč"
              photo={<ApplePieIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Jogurt"
              photo={<YogurtIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Karamel"
              photo={<CaramelIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Káva"
              photo={<CoffeeIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Kokos"
              photo={<CoconutIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Lískový oříšek"
              photo={<HazelnutIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Malaga - rozinky v rumu"
              photo={<MalagaIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Marcipán"
              photo={<MarzipanIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Máta"
              photo={<MintIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Pistácie"
              photo={<PistachioIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Protíraná višeň"
              photo={<ProtiranaVisenIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Punč"
              photo={<PuncIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Skořice"
              photo={<CinnamonIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Smetana"
              photo={<CreamIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Stracciatella"
              photo={<StracciatellaIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Tvaroh"
              photo={<TvarohIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Tiramisu"
              photo={<TiramisuIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Vanilka"
              photo={<VanillaIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Zázvor"
              photo={<GingerIcon />}
              listView={isListView}
            />
            <IceCreamCard
              title="Zelený čaj"
              photo={<GreenTeaIcon />}
              listView={isListView}
            />
          </div>
        </section>
      </main>
    </>
  );
}

interface Props {
  title: string;
  photo: ReactNode;
  listView: boolean;
}

function IceCreamCard({ title, photo, listView }: Props) {
  return (
    <>
      <div
        className={
          "flex w-full rounded-[32px] bg-white shadow-[0_4px_16px_0_rgba(0,0,0,0.08)] " +
          (listView ? "p-[20px]" : "justify-center p-[40px]")
        }
      >
        <div
          className={
            "flex " +
            (listView ? "items-center" : "flex-col items-center justify-center")
          }
        >
          <div className={listView ? "w-16" : "w-[270px]"}>{photo}</div>
          <p
            className={"font-bold text-primary " + (listView ? "ml-8" : "mt-8")}
          >
            {title}
          </p>
        </div>
      </div>
    </>
  );
}
